import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import logo from '../img/logo.svg'

const { hostname } = document.location;

function Footer() {

  const { t } = useTranslation();

  return (
    <div className='bg-[#1C1C1C] z-10 relative'>
      <div className='flex flex-col xl:flex-row container mx-auto pt-[160px]'>
        <img src={logo} alt="" className='w-[120px] ml-[30px] xl:ml-0'/>
        <div className='ml-[30px] xl:ml-[75px] gap-[15px] flex flex-col mt-[30px] xl:mt-0'>
          <p className='text-[#FFFFFF] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer1')} +442039662019</p>
          <div>
            <p className='text-[#FFFFFF] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer2')} Markus Schnurrenberger, Alpenstrasse 2, 6301 Zug</p>
          </div>
          <p className='text-[#FFFFFF] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer3')} Support@{hostname}</p>
        </div>
        <div className='ml-[30px] xl:ml-[450px] gap-[15px] flex flex-col mt-[15px] xl:mt-0'>
          <a href="/docs/conflict.pdf"><p className='text-[#FFFFFF] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer4')}</p></a>
          <a href="/docs/policy.pdf"><p className='text-[#FFFFFF] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer5')}</p></a>
          <a href="/docs/client.pdf"><p className='text-[#FFFFFF] roboto text-[14px] xl:text-[16px] font-normal'>{t('footer6')}</p></a>
        </div>
      </div>
      <div className='flex flex-col container mx-auto pl-[30px] xl:pl-[195px] pt-[40px]'>
        <p className='text-[#FFFFFF] roboto text-[12px] font-normal'>{t('footer7')}</p>
        <p className='text-[#FFFFFF] roboto text-[12px] font-light mt-[6px] pr-[30px] xl:pr-0'><Trans>{t('footer8')}</Trans></p>
        <p className='flex justify-end pb-[150px] mt-[14px] roboto text-[16px] text-[#FFFFFF] pr-[30px] xl:pr-0'>Marnex © 2025. All rights reserved.</p>      
      </div>
    </div>
  );
}

export default Footer;